// src/components/providers/SessionWrapper.tsx

"use client";

import { SessionProvider } from "next-auth/react";
export default function SessionWrapper({
  children
}: {
  children: React.ReactNode;
}) {
  return <SessionProvider data-sentry-element="SessionProvider" data-sentry-component="SessionWrapper" data-sentry-source-file="SessionWrapper.tsx">
            {children}
        </SessionProvider>;
}